import React from 'react'
import { makeIcon } from './makeIcon'

export const AirtableIcon = makeIcon({
  displayName: 'AirtableIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M7.141 1.449L1.18 3.916a.4.4 0 0 0 .005.741l5.988 2.375a2.221 2.221 0 0 0 1.638 0l5.987-2.375a.4.4 0 0 0 .005-.74L8.84 1.448a2.221 2.221 0 0 0-1.699 0z"
        fill="#FFBF00"
      />
      <path
        d="M8.522 8.329v5.932a.4.4 0 0 0 .547.372l6.671-2.59a.4.4 0 0 0 .252-.372V5.739a.4.4 0 0 0-.546-.372l-6.672 2.59a.4.4 0 0 0-.252.372z"
        fill="#26B5F8"
      />
      <path
        d="M6.964 8.635l-1.98.956-.201.097-4.18 2.003c-.265.128-.603-.065-.603-.36V5.764c0-.106.055-.198.128-.267a.454.454 0 0 1 .101-.076c.1-.06.242-.076.363-.028l6.339 2.512c.322.127.347.579.033.73z"
        fill="#ED3049"
      />
      <path
        d="M6.964 8.635l-1.98.956L.128 5.496a.454.454 0 0 1 .101-.076c.1-.06.242-.076.363-.028l6.339 2.512c.322.127.347.579.033.73z"
        fill="#000"
        fillOpacity=".25"
      />
    </g>
  ),
})

export const AirtableGreyIcon = makeIcon({
  displayName: 'AirtableGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M7.141 1.449L1.18 3.916a.4.4 0 0 0 .005.741l5.988 2.375a2.221 2.221 0 0 0 1.638 0l5.987-2.375a.4.4 0 0 0 .005-.74L8.84 1.448a2.221 2.221 0 0 0-1.699 0z" />
      <path d="M8.522 8.329v5.932a.4.4 0 0 0 .547.372l6.671-2.59a.4.4 0 0 0 .253-.372V5.739a.4.4 0 0 0-.547-.372l-6.672 2.59a.4.4 0 0 0-.252.372z" />
      <path d="M6.964 8.635l-1.98.956-.201.097-4.18 2.003c-.265.128-.603-.065-.603-.36V5.764c0-.106.055-.198.128-.267a.454.454 0 0 1 .101-.076c.1-.06.242-.076.364-.028L6.93 7.904c.322.127.347.579.033.73z" />
    </g>
  ),
})

export const AsanaIcon = makeIcon({
  displayName: 'AsanaIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
        fill="#F95353"
      />
    </g>
  ),
})

export const AsanaGreyIcon = makeIcon({
  displayName: 'AsanaGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
      />
    </g>
  ),
})

export const ClickUpIcon = makeIcon({
  displayName: 'ClickUpIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"
        fill="url(#clickup-color-radial)"
      />
      <path
        d="M7.972 12.752c3.671 0 4.917-3.303 3.39-4.352-.011 4.114-6.644 4.1-6.654 0-1.63 1.049-.406 4.352 3.264 4.352z"
        fill="#fff"
      />
      <path
        d="M10.794 5.367c1.187 1.008 1.217 1.893 1.204 2.08L8.004 4.872 4.002 7.447c-.013-.186.016-1.073 1.203-2.08.467-.363 1.478-1.228 2.148-1.805a1.003 1.003 0 0 1 1.304-.006l2.137 1.811z"
        fill="#fff"
      />
      <defs>
        <radialGradient
          id="clickup-color-radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 8) scale(10.7651)"
        >
          <stop stopColor="#6A5FD7" />
          <stop offset=".21" stopColor="#6A5FD7" />
          <stop offset="1" stopColor="#4B43AD" />
        </radialGradient>
      </defs>
    </g>
  ),
})

export const ClickUpGreyIcon = makeIcon({
  displayName: 'ClickUpGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.028 12.752c3.671 0 4.917-3.303 3.39-4.352-.011 4.114-6.644 4.1-6.654 0-1.63 1.049-.406 4.352 3.264 4.352zm4.026-5.305c.013-.187-.017-1.072-1.204-2.08L8.657 3.556a1.003 1.003 0 0 0-1.304.006c-.67.577-1.681 1.442-2.148 1.805-1.187 1.007-1.216 1.894-1.203 2.08l4.002-2.575 3.994 2.575z"
      />
    </g>
  ),
})

export const SlackIcon = makeIcon({
  displayName: 'SlackIcon',
  content: (
    <g>
      <path
        d="M7.56 1.68v1.68H5.88a1.68 1.68 0 1 1 1.68-1.68z"
        fill="#36C5F0"
      />
      <path
        d="M14.32 7.56h-1.68V5.88a1.68 1.68 0 1 1 1.68 1.68zM11.79 5.88a1.68 1.68 0 1 1-3.36-.001l.001-4.199a1.68 1.68 0 0 1 3.361.001l-.001 4.2z"
        fill="#2EB67D"
      />
      <path
        d="M8.446 14.32v-1.68h1.68a1.68 1.68 0 1 1-1.68 1.68zM10.117 11.79a1.68 1.68 0 1 1 0-3.36l4.202-.001a1.68 1.68 0 1 1 0 3.361h-4.202z"
        fill="#ECB22E"
      />
      <path
        d="M1.68 8.44h1.68v1.68a1.68 1.68 0 1 1-1.68-1.68zM4.22 10.12a1.68 1.68 0 0 1 3.36.001l-.001 4.199a1.68 1.68 0 0 1-3.361-.001l.001-4.2z"
        fill="#E01E5A"
      />
      <path
        d="M5.88 4.22a1.68 1.68 0 0 1-.001 3.36L1.68 7.579a1.68 1.68 0 1 1 .001-3.361l4.2.001z"
        fill="#36C5F0"
      />
    </g>
  ),
})

export const GoogleDocsIcon = makeIcon({
  displayName: 'GoogleDocsIcon',
  viewBox: 16,
  content: (
    <>
      <g clipPath="url(#clip0_2074_28450)">
        <path
          d="M9.43096 0.5H3.28481C2.68827 0.5 2.2002 0.990909 2.2002 1.59091V15.4091C2.2002 16.0091 2.68827 16.5 3.28481 16.5H12.6848C13.2813 16.5 13.7694 16.0091 13.7694 15.4091V4.86364L11.2387 3.04545L9.43096 0.5Z"
          fill="#4285F4"
        />
        <path
          d="M9.74854 4.54688L13.7697 8.59051V4.86597L9.74854 4.54688Z"
          fill="url(#paint0_linear_2074_28450)"
        />
        <path
          d="M5.09277 12.1364H10.8774V11.4091H5.09277V12.1364ZM5.09277 13.5909H9.43124V12.8636H5.09277V13.5909ZM5.09277 8.5V9.22727H10.8774V8.5H5.09277ZM5.09277 10.6818H10.8774V9.95455H5.09277V10.6818Z"
          fill="#F1F1F1"
        />
        <path
          d="M9.43164 0.5V3.77273C9.43164 4.37545 9.91701 4.86364 10.5163 4.86364H13.7701L9.43164 0.5Z"
          fill="#A1C2FA"
        />
        <path
          d="M3.28481 0.5C2.68827 0.5 2.2002 0.990909 2.2002 1.59091V1.68182C2.2002 1.08182 2.68827 0.590909 3.28481 0.590909H9.43096V0.5H3.28481Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M12.6848 16.4093H3.28481C2.68827 16.4093 2.2002 15.9184 2.2002 15.3184V15.4093C2.2002 16.0093 2.68827 16.5002 3.28481 16.5002H12.6848C13.2813 16.5002 13.7694 16.0093 13.7694 15.4093V15.3184C13.7694 15.9184 13.2813 16.4093 12.6848 16.4093Z"
          fill="#1A237E"
          fillOpacity="0.2"
        />
        <path
          d="M10.5163 4.86435C9.91701 4.86435 9.43164 4.37616 9.43164 3.77344V3.86435C9.43164 4.46707 9.91701 4.95526 10.5163 4.95526H13.7701V4.86435H10.5163Z"
          fill="#1A237E"
          fillOpacity="0.1"
        />
        <path
          d="M9.43096 0.5H3.28481C2.68827 0.5 2.2002 0.990909 2.2002 1.59091V15.4091C2.2002 16.0091 2.68827 16.5 3.28481 16.5H12.6848C13.2813 16.5 13.7694 16.0091 13.7694 15.4091V4.86364L9.43096 0.5Z"
          fill="url(#paint1_radial_2074_28450)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2074_28450"
          x1="11.7594"
          y1="4.89407"
          x2="11.7594"
          y2="8.59108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A237E" stopOpacity="0.2" />
          <stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2074_28450"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.56671 0.816239) scale(18.6552 18.6552)"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_2074_28450">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
})

export const GoogleIcon = makeIcon({
  displayName: 'GoogleIcon',
  viewBox: 18,
  content: (
    <g id="Google-Button" stroke="none" fill="none">
      <g
        id="btn_google_dark_normal"
        transform="translate(-15.000000, -15.000000)"
      >
        <g id="logo_googleg_48dp" transform="translate(15.000000, 15.000000)">
          <path
            d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
            id="Shape"
            fill="#4285F4"
          />
          <path
            d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
            id="Shape"
            fill="#34A853"
          />
          <path
            d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
            id="Shape"
            fill="#FBBC05"
          />
          <path
            d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
            id="Shape"
            fill="#EA4335"
          />
          <polygon id="Shape" points="0 0 18 0 18 18 0 18" />
        </g>
      </g>
    </g>
  ),
})

export const GooglePlayIcon = makeIcon({
  displayName: 'GooglePlayIcon',
  viewBoxHeight: 24,
  viewBoxWidth: 21,
  content: (
    <path d="M1.101 0l11.22 11.225 3.077-3.1L1.798.212A1.48 1.48 0 0 0 1.1 0zm-.94.522A1.295 1.295 0 0 0 0 1.158v21.814c0 .175.036.333.097.473l11.48-11.486L.162.522zm16.176 8.141L13.05 11.96l3.287 3.28 4.015-2.317c.571-.333.652-.755.648-.98-.006-.37-.239-.717-.632-.93-.342-.185-2.882-1.675-4.031-2.349zm-4.016 4.03L1.004 24c.188-.01.392-.051.583-.163.443-.26 9.407-5.482 9.407-5.482l4.42-2.562-3.093-3.1z" />
  ),
})

export const GoogleDriveIconMonochrome = makeIcon({
  displayName: 'GoogleDriveIconMonochrome',
  viewBox: 16,
  content: (
    <path
      fill="#currentColor"
      fillRule="evenodd"
      d="M0 10.15 2.8 15h10.4l2.8-4.85L10.8 1H5.2L0 10.15Zm10.382-.025L8 6l-2.382 4.125h4.764Z"
      clipRule="evenodd"
    />
  ),
})

export const LinkedInIcon = makeIcon({
  displayName: 'LinkedInIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8158 0H1.18089C0.529332 0 0 0.516445 0 1.15322V14.8454C0 15.4828 0.529332 16 1.18089 16H14.8158C15.4684 16 16.0002 15.4828 16.0002 14.8454V1.15322C16.0002 0.516445 15.4684 0 14.8158 0ZM3.55922 2.20278C4.3181 2.20278 4.93455 2.81934 4.93455 3.57834C4.93455 4.33789 4.3181 4.95467 3.55922 4.95467C2.79877 4.95467 2.18311 4.33789 2.18311 3.57834C2.18311 2.81934 2.79877 2.20278 3.55922 2.20278ZM2.37222 5.99845H4.74533V13.6341H2.37222V5.99845ZM8.51032 5.99844H6.23376V13.6341H8.60521V9.85678C8.60521 8.86077 8.79432 7.89611 10.0293 7.89611C11.2462 7.89611 11.2625 9.035 11.2625 9.92089V13.6341H13.634V9.44578C13.634 7.38989 13.1903 5.80844 10.7872 5.80844C9.63276 5.80844 8.85854 6.44144 8.54188 7.04166H8.51032V5.99844Z"
    />
  ),
})

export const ConfluenceIcon = makeIcon({
  displayName: 'ConfluenceIcon',
  viewBox: 16,
  content: (
    <>
      <g clipPath="url(#clip0_2074_28451)">
        <path
          d="M15.8184 3.59454C16.0375 3.25299 15.9277 2.80148 15.5839 2.58597C14.864 2.13476 13.65 1.3739 12.6947 0.775747C12.34 0.553633 11.875 0.667632 11.6435 1.0163C10.2639 3.09432 9.0351 3.73003 6.28589 2.40472C5.4493 2.00273 4.04955 1.32421 3.20673 0.915267C2.82158 0.728385 2.35928 0.900774 2.18941 1.29373C1.72764 2.36186 1.13607 3.71759 0.789519 4.51067C0.627911 4.88051 0.787404 5.31068 1.15099 5.4859C1.98266 5.88673 3.41657 6.5779 4.27021 6.99C9.32294 9.51854 13.0388 7.92767 15.8184 3.59454Z"
          fill="url(#paint0_linear_2074_28451)"
        />
        <path
          d="M0.1821 13.4016C-0.0370016 13.7431 0.0727513 14.1946 0.416583 14.4101C1.13647 14.8613 2.35053 15.6222 3.30577 16.2203C3.66048 16.4425 4.1255 16.3285 4.35698 15.9798C5.73661 13.9018 6.96539 13.2661 9.7146 14.5914C10.5512 14.9934 11.9509 15.6719 12.7938 16.0808C13.1789 16.2677 13.6412 16.0953 13.8111 15.7024C14.2728 14.6342 14.8644 13.2785 15.211 12.4854C15.3726 12.1156 15.2131 11.6854 14.8495 11.5102C14.0178 11.1094 12.5839 10.4182 11.7303 10.0061C6.67755 7.47755 2.96174 9.06843 0.1821 13.4016Z"
          fill="url(#paint1_linear_2074_28451)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2074_28451"
          x1="1.07441"
          y1="-0.710464"
          x2="4.91853"
          y2="7.91591"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2074_28451"
          x1="14.9261"
          y1="17.7066"
          x2="11.082"
          y2="9.08018"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <clipPath id="clip0_2074_28451">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
})

export const TwitterXIcon = makeIcon({
  displayName: 'TwitterXIcon',
  viewBox: 16,
  content: (
    <path d="M9.31264 6.77143L15.1379 0H13.7575L8.69942 5.87954L4.65953 0H0L6.10911 8.8909L0 15.9918H1.38049L6.72197 9.78279L10.9884 15.9918H15.6479L9.3123 6.77143H9.31264ZM7.42187 8.96923L6.8029 8.0839L1.87789 1.03921H3.99824L7.97277 6.7245L8.59175 7.60983L13.7582 14.9998H11.6378L7.42187 8.96957V8.96923Z" />
  ),
})

export const ConfluenceIconMonochrome = makeIcon({
  displayName: 'ConfluenceIconMonochrome',
  viewBoxWidth: 24,
  viewBoxHeight: 25,
  content: (
    <>
      <path
        fill="url(#confluence-icon-gradient-a)"
        d="M23.923 4.836a.734.734 0 0 0-.238-1.01L18.72.717a.765.765 0 0 0-1.047.243c-2.157 3.37-3.983 4.456-8.244 2.402-1.381-.664-3.786-1.83-4.973-2.406a.75.75 0 0 0-1.017.38c-.776 1.799-1.882 4.331-2.4 5.517a.747.747 0 0 0 .361.974l5.005 2.413c7.698 3.852 13.328 1.33 17.518-5.403Z"
      />
      <path
        fill="url(#confluence-icon-gradient-b)"
        d="M.077 20.164a.734.734 0 0 0 .238 1.01l4.965 3.11a.765.765 0 0 0 1.047-.243c2.157-3.37 3.983-4.456 8.245-2.402 1.38.664 3.785 1.83 4.972 2.406a.75.75 0 0 0 1.017-.38c.776-1.799 1.882-4.331 2.4-5.517a.747.747 0 0 0-.361-.974l-5.005-2.413C9.897 10.91 4.268 13.431.077 20.164Z"
      />
      <defs>
        <linearGradient
          id="confluence-icon-gradient-a"
          x1="1.611"
          x2="7.378"
          y1="-1.312"
          y2="11.628"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="confluence-icon-gradient-b"
          x1="22.389"
          x2="16.622"
          y1="26.312"
          y2="13.372"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </>
  ),
})

export const ConfluenceGreyIcon = makeIcon({
  displayName: 'ConfluenceGreyIcon',
  content: (
    <g>
      <path d="M15.948 2.891a.49.49 0 0 0-.158-.673L12.48.144a.51.51 0 0 0-.698.162c-1.438 2.247-2.655 2.97-5.496 1.601C5.365 1.465 3.762.687 2.97.303a.5.5 0 0 0-.677.253c-.518 1.2-1.255 2.888-1.6 3.679a.498.498 0 0 0 .24.649L4.27 6.493c5.132 2.568 8.885.886 11.678-3.602ZM.051 13.109a.49.49 0 0 0 .16.673l3.309 2.074a.51.51 0 0 0 .698-.162c1.438-2.247 2.655-2.97 5.496-1.602.921.443 2.524 1.22 3.316 1.605a.5.5 0 0 0 .677-.253 971.72 971.72 0 0 1 1.6-3.679.498.498 0 0 0-.24-.649L11.73 9.507C6.598 6.94 2.845 8.621.051 13.11Z" />
    </g>
  ),
})

export const DrawIOIcon = makeIcon({
  displayName: 'DrawIOIcon',
  viewBox: 719,
  content: (
    <g
      transform="translate(0.000000,719.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M0 3595 l0 -3595 3595 0 3595 0 0 3595 0 3595 -3595 0 -3595 0 0 -3595z m4319 2735 c162 -27 286 -148 321 -313 7 -36 10 -238 8 -623 -3 -569 -3 -569 -26 -626 -35 -86 -108 -160 -202 -206 l-78 -38 397 -677 396 -677 370 0 c398 -1 493 -8 564 -42 71 -34 154 -119 187 -191 l29 -62 0 -620 0 -620 -32 -66 c-40 -81 -102 -140 -191 -182 l-67 -32 -765 0 -765 0 -63 29 c-81 37 -171 131 -204 213 l-23 58 0 605 0 605 32 67 c76 162 212 237 431 238 28 0 52 2 52 4 0 1 -177 304 -393 672 l-394 669 -310 3 -310 2 -392 -668 c-215 -368 -391 -671 -391 -674 0 -3 45 -8 101 -12 159 -11 251 -56 329 -159 77 -102 75 -79 75 -757 l0 -605 -32 -67 c-54 -115 -150 -191 -273 -217 -40 -9 -250 -11 -785 -9 l-730 3 -65 31 c-113 53 -171 119 -210 233 -20 61 -21 76 -18 659 l3 597 27 57 c47 101 140 182 253 221 18 6 200 13 449 16 l419 6 393 670 c216 369 393 674 394 678 0 4 -8 10 -17 13 -133 42 -226 133 -267 260 -15 45 -16 117 -14 655 l3 604 27 56 c54 109 173 198 290 218 77 13 1388 13 1467 1z" />
    </g>
  ),
})

export const FigmaIcon = makeIcon({
  displayName: 'FigmaIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#figma-color-clip)">
        <path
          d="M5.667 16a2.668 2.668 0 0 0 2.667-2.667v-2.667H5.667a2.668 2.668 0 0 0 0 5.334z"
          fill="#0ACF83"
        />
        <path
          d="M3 8a2.668 2.668 0 0 1 2.667-2.667h2.667v5.333H5.667A2.667 2.667 0 0 1 3 8z"
          fill="#A259FF"
        />
        <path
          d="M3 2.667A2.668 2.668 0 0 1 5.667 0h2.667v5.333H5.667A2.667 2.667 0 0 1 3 2.667z"
          fill="#F24E1E"
        />
        <path
          d="M8.333 0H11a2.667 2.667 0 0 1 0 5.333H8.333V0z"
          fill="#FF7262"
        />
        <path
          d="M13.667 8a2.668 2.668 0 0 1-5.334 0 2.668 2.668 0 0 1 5.334 0z"
          fill="#1ABCFE"
        />
      </g>
      <defs>
        <clipPath id="figma-color-clip">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const FigmaGreyIcon = makeIcon({
  displayName: 'FigmaGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M5.668 16a2.668 2.668 0 0 0 2.666-2.667v-2.666H5.668a2.668 2.668 0 0 0 0 5.333z" />
      <path d="M3.001 8a2.668 2.668 0 0 1 2.667-2.667h2.666v5.334H5.668A2.668 2.668 0 0 1 3 8z" />
      <path d="M3.001 2.667A2.668 2.668 0 0 1 5.668 0h2.666v5.333H5.668A2.668 2.668 0 0 1 3 2.667z" />
      <path d="M8.334 0h2.667a2.668 2.668 0 0 1 0 5.333H8.334V0z" />
      <path d="M13.668 8a2.668 2.668 0 0 1-5.334 0 2.668 2.668 0 0 1 5.334 0z" />
    </g>
  ),
})

export const GoogleDriveIcon = makeIcon({
  displayName: 'GoogleDriveIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="#00AC47"
        d="M8.002 5.607 5.485 1.244a.779.779 0 0 1 .276-.175c-.742.24-1.083 1.059-1.083 1.059L.08 10.095a2.3 2.3 0 0 0-.075.674h5.019l2.978-5.162Z"
      />
      <path
        fill="#FFBA00"
        d="m8.002 5.607 2.978 5.162h5.018a2.3 2.3 0 0 0-.074-.674l-4.598-7.967s-.342-.819-1.083-1.059a.787.787 0 0 1 .276.175L8.002 5.607Z"
      />
      <path
        fill="#00832D"
        d="m8.002 5.607 2.516-4.363a.779.779 0 0 0-.276-.175 1.382 1.382 0 0 0-.355-.065H6.115a1.316 1.316 0 0 0-.355.065.787.787 0 0 0-.276.175l2.517 4.363Z"
      />
      <path
        fill="#2684FC"
        d="m5.024 10.77-2.488 4.312s-.083-.04-.195-.12c.353.266.696.323.696.323h9.772c.54 0 .652-.203.652-.203l.004-.002-2.486-4.31H5.024Z"
      />
      <path
        fill="#0066DA"
        d="M5.024 10.77H.005c.026.585.284.928.284.928l.189.321.022.03.41.708.922 1.576c.027.064.059.122.092.178.012.019.024.04.038.058l.01.016c.114.158.242.28.37.376.112.083.195.121.195.121l2.488-4.313h-.001Z"
      />
      <path
        fill="#EA4335"
        d="M10.979 10.77h5.018c-.025.585-.284.928-.284.928l-.188.321-.022.03-.41.708-.922 1.576a1.449 1.449 0 0 1-.092.178c-.013.019-.024.04-.038.058l-.01.016a1.75 1.75 0 0 1-.37.376c-.112.083-.195.121-.195.121l-2.488-4.313Z"
      />
    </g>
  ),
})

export const GoogleDriveGreyIcon = makeIcon({
  displayName: 'GoogleDriveGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.15L2.8 15h10.4l2.8-4.85L10.8 1H5.2L0 10.15zm10.382-.025L8 6l-2.382 4.125h4.764z"
      />
    </g>
  ),
})

export const GoogleMapsIcon = makeIcon({
  displayName: 'GoogleMapsIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#google-maps-color-path-0)">
        <path
          d="M7.994 0C5.18 0 2.9 2.177 2.9 4.863c.002.838.201 1.662.635 2.39.131.214.253.428.362.64.1.153.197.306.288.458.104.145.204.29.3.437.398.537.76 1.064 1.105 1.57.24.387.51.801.748 1.211.718 1.243 1.217 2.457 1.397 4.225v.004c.055.124.157.202.267.202.122 0 .233-.095.282-.242.183-1.748.68-2.954 1.392-4.189.238-.41.508-.824.749-1.212.345-.505.707-1.032 1.104-1.569.096-.146.196-.292.3-.437.091-.152.188-.305.289-.458.109-.212.23-.426.361-.64.433-.729.607-1.552.609-2.39C13.088 2.177 10.808 0 7.994 0z"
          fill="#DD4B3E"
        />
        <path
          d="M7.994 6.552c.977 0 1.77-.757 1.77-1.69 0-.932-.793-1.689-1.77-1.689-.978 0-1.77.757-1.77 1.69 0 .932.792 1.689 1.77 1.689z"
          fill="#802D27"
        />
      </g>
      <defs>
        <clipPath id="google-maps-color-path-0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const GoogleMapsGreyIcon = makeIcon({
  displayName: 'GoogleMapsGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#google-maps-grey-path-0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.9 4.863C2.9 2.177 5.18 0 7.994 0c2.813 0 5.094 2.177 5.094 4.863-.001.838-.176 1.661-.609 2.39-.13.214-.252.428-.361.64-.101.153-.198.306-.288.458-.105.145-.205.29-.3.437a49.39 49.39 0 0 0-1.105 1.57 59.06 59.06 0 0 1-.221.351c-.178.282-.36.572-.528.86-.712 1.234-1.209 2.44-1.392 4.189-.049.147-.16.242-.282.242-.11 0-.212-.078-.267-.202v-.004c-.18-1.768-.68-2.982-1.397-4.225-.167-.288-.35-.578-.527-.86-.076-.119-.15-.236-.221-.351a49.486 49.486 0 0 0-1.105-1.57 11.41 11.41 0 0 0-.3-.437c-.09-.152-.187-.305-.288-.458a9.772 9.772 0 0 0-.362-.64c-.434-.728-.633-1.552-.635-2.39zm6.863 0c0 .932-.792 1.689-1.77 1.689-.976 0-1.769-.757-1.769-1.69 0-.932.793-1.689 1.77-1.689s1.77.757 1.77 1.69z"
        />
      </g>
      <defs>
        <clipPath id="google-maps-grey-path-0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const GitHubIcon = makeIcon({
  displayName: 'GitHubIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M8 .197A8.001 8.001 0 0 0 5.472 15.79c.4.074.547-.174.547-.384 0-.192-.008-.821-.011-1.49-2.226.484-2.696-.943-2.696-.943-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.87 2.328.665.072-.517.28-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.953 0-.874.313-1.587.825-2.148-.084-.201-.357-1.015.077-2.117 0 0 .672-.215 2.2.82a7.59 7.59 0 0 1 4.007 0c1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.078 2.117.512.56.824 1.274.824 2.148 0 3.072-1.872 3.749-3.653 3.947.288.248.544.736.544 1.482 0 1.07-.01 1.931-.01 2.195 0 .213.145.462.55.384A8.005 8.005 0 0 0 16 8.197a8 8 0 0 0-8-8zM2.996 11.594c-.017.04-.08.051-.137.024-.057-.027-.09-.08-.071-.12.018-.04.08-.052.137-.025.058.027.091.08.071.12zm.394.352c-.038.035-.113.018-.163-.037-.051-.057-.063-.13-.024-.167.038-.035.112-.019.164.037.053.056.063.13.023.166zm.27.448c-.05.034-.128.002-.179-.07-.05-.07-.049-.156 0-.191.049-.036.128-.004.179.067.05.07.05.16 0 .194zm.456.52c-.043.048-.137.035-.205-.032-.069-.067-.09-.156-.046-.205.044-.048.139-.034.208.032.069.067.09.158.043.206v-.001zm.59.175c-.019.064-.109.091-.2.064-.09-.027-.15-.1-.131-.164.018-.063.11-.093.2-.064.092.029.15.101.132.165zm.673.075c.002.066-.075.12-.17.122-.095.001-.173-.051-.174-.116-.001-.065.075-.121.17-.123.096-.001.173.052.173.117zm.66-.025c.01.064-.055.13-.15.148-.095.017-.179-.023-.19-.087-.012-.064.055-.132.148-.15.093-.016.179.024.19.09l.001-.001z"
        fill="#161614"
      />
    </g>
  ),
})

export const GitLabIcon = makeIcon({
  displayName: 'GitLabIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.7336 6.33241L15.7112 6.27273L13.5334 0.372158C13.4891 0.25651 13.4107 0.158405 13.3093 0.0919202C13.2079 0.0265645 13.0896 -0.00491288 12.9705 0.00173808C12.8513 0.00838904 12.7369 0.0528481 12.6428 0.129112C12.5498 0.207566 12.4823 0.313874 12.4496 0.433568L10.9791 5.10421H5.02496L3.55454 0.433568C3.52265 0.313222 3.45502 0.206381 3.36126 0.128247C3.26719 0.051983 3.15284 0.00752392 3.03365 0.000872965C2.91447 -0.00577799 2.79619 0.0256994 2.69478 0.0910551C2.59367 0.157809 2.51528 0.255828 2.47068 0.371293L0.288786 6.26927L0.267125 6.32895C-0.0463686 7.17936 -0.0850642 8.11253 0.156872 8.98776C0.398809 9.86299 0.908262 10.6328 1.60842 11.1812L1.61592 11.1873L1.63591 11.202L4.95332 13.7812L6.59453 15.0708L7.59425 15.8545C7.71119 15.9466 7.85398 15.9965 8.0008 15.9965C8.14763 15.9965 8.29042 15.9466 8.40736 15.8545L9.40708 15.0708L11.0483 13.7812L14.3857 11.1864L14.394 11.1795C15.0926 10.631 15.6009 9.86195 15.8424 8.9879C16.084 8.11385 16.0458 7.18201 15.7336 6.33241Z"
        fill="#E24329"
      />
      <path
        d="M15.7336 6.33239L15.7112 6.27271C14.65 6.49883 13.6501 6.96548 12.7828 7.6393L7.99997 11.394C9.62868 12.6732 11.0466 13.7847 11.0466 13.7847L14.384 11.1899L14.3924 11.1829C15.0919 10.6345 15.601 9.86491 15.8429 8.99011C16.0848 8.11531 16.0465 7.18261 15.7336 6.33239Z"
        fill="#FC6D26"
      />
      <path
        d="M4.95331 13.7847L6.59452 15.0743L7.59424 15.8579C7.71118 15.9501 7.85397 16 8.00079 16C8.14762 16 8.29041 15.9501 8.40735 15.8579L9.40707 15.0743L11.0483 13.7847C11.0483 13.7847 9.62867 12.6698 7.99996 11.394C6.37125 12.6698 4.95331 13.7847 4.95331 13.7847Z"
        fill="#FCA326"
      />
      <path
        d="M3.2163 7.63934C2.34971 6.96413 1.34999 6.49627 0.288786 6.26929L0.267125 6.32897C-0.0463686 7.17937 -0.0850642 8.11254 0.156872 8.98778C0.398809 9.86301 0.908262 10.6329 1.60842 11.1812L1.61592 11.1873L1.63591 11.202L4.95332 13.7812C4.95332 13.7812 6.36959 12.6698 7.99997 11.3906L3.2163 7.63934Z"
        fill="#FC6D26"
      />
    </g>
  ),
})

export const GitHubGreyIcon = makeIcon({
  displayName: 'GitHubGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M8 .197A8.001 8.001 0 0 0 5.472 15.79c.4.074.547-.174.547-.384 0-.192-.008-.821-.011-1.49-2.226.484-2.696-.943-2.696-.943-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.87 2.328.665.072-.517.28-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.953 0-.874.313-1.587.825-2.148-.084-.201-.357-1.015.077-2.117 0 0 .672-.215 2.2.82a7.59 7.59 0 0 1 4.007 0c1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.078 2.117.512.56.824 1.274.824 2.148 0 3.072-1.872 3.749-3.653 3.947.288.248.544.736.544 1.482 0 1.07-.01 1.931-.01 2.195 0 .213.145.462.55.384A8.005 8.005 0 0 0 16 8.197a8 8 0 0 0-8-8z" />
    </g>
  ),
})

export const LoomIcon = makeIcon({
  displayName: 'LoomIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M16 7.11032H11.3214L15.3733 4.77095L14.4835 3.22928L10.4315 5.56865L12.7704 1.51705L11.2287 0.626696L8.88986 4.67829V0H7.11012V4.67873L4.77037 0.626696L3.22919 1.5166L5.56849 5.5682L1.51656 3.22928L0.626679 4.7705L4.67861 7.10987H0V8.8897H4.67816L0.626679 11.2291L1.51656 12.7707L5.56804 10.4318L3.22874 14.4834L4.77037 15.3733L7.10967 11.3213V16H8.88944V11.3217L11.2283 15.3733L12.7699 14.4834L10.4306 10.4314L14.4825 12.7707L15.3724 11.2291L11.3209 8.89012H15.9991V7.11032H16ZM8 10.4206C6.65802 10.4206 5.57028 9.33288 5.57028 7.99083C5.57028 6.6488 6.65802 5.56104 8 5.56104C9.34199 5.56104 10.4297 6.6488 10.4297 7.99083C10.4297 9.33288 9.34199 10.4206 8 10.4206Z"
        fill="#625DF5"
      />
    </g>
  ),
})

export const LoomGreyIcon = makeIcon({
  displayName: 'LoomGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M16 7.11032H11.3214L15.3733 4.77095L14.4835 3.22928L10.4315 5.56865L12.7704 1.51705L11.2287 0.626696L8.88986 4.67829V0H7.11012V4.67873L4.77037 0.626696L3.22919 1.5166L5.56849 5.5682L1.51656 3.22928L0.626679 4.7705L4.67861 7.10987H0V8.8897H4.67816L0.626679 11.2291L1.51656 12.7707L5.56804 10.4318L3.22874 14.4834L4.77037 15.3733L7.10967 11.3213V16H8.88944V11.3217L11.2283 15.3733L12.7699 14.4834L10.4306 10.4314L14.4825 12.7707L15.3724 11.2291L11.3209 8.89012H15.9991V7.11032H16ZM8 10.4206C6.65802 10.4206 5.57028 9.33288 5.57028 7.99083C5.57028 6.6488 6.65802 5.56104 8 5.56104C9.34199 5.56104 10.4297 6.6488 10.4297 7.99083C10.4297 9.33288 9.34199 10.4206 8 10.4206Z" />
    </g>
  ),
})

export const TrelloIcon = makeIcon({
  displayName: 'TrelloIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#trello-color-clip-0)">
        <path
          d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          fill="#3279BA"
        />
        <path
          d="M7 12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v9zm7-4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="trello-color-clip-0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const TrelloGreyIcon = makeIcon({
  displayName: 'TrelloGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm6 11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3zm7-4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3z"
      />
    </g>
  ),
})

export const IntercomIcon = makeIcon({
  displayName: 'IntercomIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M13.8667 8.79677C13.8667 9.09131 13.6279 9.33011 13.3333 9.33011C13.0388 9.33011 12.8 9.09131 12.8 8.79677V4C12.8 3.70547 13.0388 3.46667 13.3333 3.46667C13.6279 3.46667 13.8667 3.70547 13.8667 4V8.79677ZM13.6805 12.1351C13.5981 12.2056 11.6224 13.8635 8.00003 13.8635C4.37764 13.8635 2.40198 12.2056 2.31958 12.135C2.09598 11.9433 2.0701 11.6066 2.26176 11.3829C2.45302 11.1597 2.78879 11.1333 3.01255 11.3241C3.0439 11.3503 4.8081 12.7967 8.00003 12.7968C11.232 12.7968 12.969 11.3398 12.9862 11.3252C13.2094 11.1335 13.5467 11.1593 13.7383 11.383C13.93 11.6066 13.9041 11.9434 13.6805 12.1351ZM2.13333 4C2.13333 3.70547 2.37212 3.46667 2.66666 3.46667C2.96124 3.46667 3.19999 3.70547 3.19999 4V8.79677C3.19999 9.09125 2.96124 9.33005 2.66666 9.33005C2.37212 9.33005 2.13333 9.09125 2.13333 8.79672V4ZM4.80004 2.93333C4.80004 2.6388 5.03884 2.4 5.33337 2.4C5.6279 2.4 5.8667 2.6388 5.8667 2.93333V10.0584C5.8667 10.3529 5.6279 10.5917 5.33337 10.5917C5.03884 10.5917 4.80004 10.3529 4.80004 10.0584V2.93333ZM7.46669 2.66347C7.46669 2.3688 7.70549 2.13013 8.00003 2.13013C8.29456 2.13013 8.53336 2.3688 8.53336 2.66347V10.3968C8.53336 10.6913 8.29456 10.9301 8.00003 10.9301C7.70549 10.9301 7.46669 10.6913 7.46669 10.3968V2.66347ZM10.1334 2.93333C10.1334 2.6388 10.3722 2.4 10.6667 2.4C10.9612 2.4 11.2 2.6388 11.2 2.93333V10.0584C11.2 10.3529 10.9612 10.5917 10.6667 10.5917C10.3722 10.5917 10.1334 10.3529 10.1334 10.0584V2.93333ZM14 0H1.99999C0.895465 0 0 0.895467 0 2L5.20832e-05 14C5.20832e-05 15.1045 0.895465 16 1.99999 16H14C15.1045 16 16 15.1045 16 14V2C16 0.895467 15.1045 0 14 0Z"
        fill="#1F8DED"
      />
    </g>
  ),
})

export const IntercomGreyIcon = makeIcon({
  displayName: 'IntercomGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M13.8667 8.79677C13.8667 9.09131 13.6279 9.33011 13.3333 9.33011C13.0388 9.33011 12.8 9.09131 12.8 8.79677V4C12.8 3.70547 13.0388 3.46667 13.3333 3.46667C13.6279 3.46667 13.8667 3.70547 13.8667 4V8.79677ZM13.6805 12.1351C13.5981 12.2056 11.6224 13.8635 8.00003 13.8635C4.37764 13.8635 2.40198 12.2056 2.31958 12.135C2.09598 11.9433 2.0701 11.6066 2.26176 11.3829C2.45302 11.1597 2.78879 11.1333 3.01255 11.3241C3.0439 11.3503 4.8081 12.7967 8.00003 12.7968C11.232 12.7968 12.969 11.3398 12.9862 11.3252C13.2094 11.1335 13.5467 11.1593 13.7383 11.383C13.93 11.6066 13.9041 11.9434 13.6805 12.1351ZM2,0A2,2,0,0,1,2,2H14a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H0A2,2,0,0,1-0-0Z" />
    </g>
  ),
})

export const LinearIcon = makeIcon({
  displayName: 'LinearIcon',
  viewBox: 100,
  content: (
    <g>
      <path
        fill="#5E6AD2"
        d="M1.22541 61.5228c-.2225-.9485.90748-1.5459 1.59638-.857L39.3342 97.1782c.6889.6889.0915 1.8189-.857 1.5964C20.0515 94.4522 5.54779 79.9485 1.22541 61.5228ZM.00189135 46.8891c-.01764375.2833.08887215.5599.28957165.7606L52.3503 99.7085c.2007.2007.4773.3075.7606.2896 2.3692-.1476 4.6938-.46 6.9624-.9259.7645-.157 1.0301-1.0963.4782-1.6481L2.57595 39.4485c-.55186-.5519-1.49117-.2863-1.648174.4782-.465915 2.2686-.77832 4.5932-.92588465 6.9624ZM4.21093 29.7054c-.16649.3738-.08169.8106.20765 1.1l64.77602 64.776c.2894.2894.7262.3742 1.1.2077 1.7861-.7956 3.5171-1.6927 5.1855-2.684.5521-.328.6373-1.0867.1832-1.5407L8.43566 24.3367c-.45409-.4541-1.21271-.3689-1.54074.1832-.99132 1.6684-1.88843 3.3994-2.68399 5.1855ZM12.6587 18.074c-.3701-.3701-.393-.9637-.0443-1.3541C21.7795 6.45931 35.1114 0 49.9519 0 77.5927 0 100 22.4073 100 50.0481c0 14.8405-6.4593 28.1724-16.7199 37.3375-.3903.3487-.984.3258-1.3542-.0443L12.6587 18.074Z"
      />
    </g>
  ),
})

export const LinearGreyIcon = makeIcon({
  displayName: 'LinearGreyIcon',
  viewBox: 100,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M1.22541 61.5228c-.2225-.9485.90748-1.5459 1.59638-.857L39.3342 97.1782c.6889.6889.0915 1.8189-.857 1.5964C20.0515 94.4522 5.54779 79.9485 1.22541 61.5228ZM.00189135 46.8891c-.01764375.2833.08887215.5599.28957165.7606L52.3503 99.7085c.2007.2007.4773.3075.7606.2896 2.3692-.1476 4.6938-.46 6.9624-.9259.7645-.157 1.0301-1.0963.4782-1.6481L2.57595 39.4485c-.55186-.5519-1.49117-.2863-1.648174.4782-.465915 2.2686-.77832 4.5932-.92588465 6.9624ZM4.21093 29.7054c-.16649.3738-.08169.8106.20765 1.1l64.77602 64.776c.2894.2894.7262.3742 1.1.2077 1.7861-.7956 3.5171-1.6927 5.1855-2.684.5521-.328.6373-1.0867.1832-1.5407L8.43566 24.3367c-.45409-.4541-1.21271-.3689-1.54074.1832-.99132 1.6684-1.88843 3.3994-2.68399 5.1855ZM12.6587 18.074c-.3701-.3701-.393-.9637-.0443-1.3541C21.7795 6.45931 35.1114 0 49.9519 0 77.5927 0 100 22.4073 100 50.0481c0 14.8405-6.4593 28.1724-16.7199 37.3375-.3903.3487-.984.3258-1.3542-.0443L12.6587 18.074Z"
      />
    </g>
  ),
})

export const TwitterIcon = makeIcon({
  displayName: 'TwitterIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M5.079 14.5c5.944 0 9.196-5.002 9.196-9.34 0-.142 0-.283-.01-.424a6.634 6.634 0 0 0 1.613-1.699c-.59.266-1.216.44-1.857.517a3.285 3.285 0 0 0 1.421-1.816 6.417 6.417 0 0 1-2.052.797 3.22 3.22 0 0 0-1.834-.992 3.192 3.192 0 0 0-2.049.346 3.266 3.266 0 0 0-1.42 1.54 3.333 3.333 0 0 0-.205 2.1 9.065 9.065 0 0 1-3.69-.996 9.204 9.204 0 0 1-2.97-2.434A3.33 3.33 0 0 0 .866 4.49c.186.814.67 1.526 1.355 1.99A3.17 3.17 0 0 1 .755 6.07v.041c0 .758.259 1.493.731 2.08.473.586 1.13.988 1.862 1.138a3.179 3.179 0 0 1-1.46.056 3.285 3.285 0 0 0 1.15 1.632 3.204 3.204 0 0 0 1.87.648 6.422 6.422 0 0 1-4.783 1.36 9.047 9.047 0 0 0 4.954 1.472"
        fill="#1DA1F2"
      />
    </g>
  ),
})

export const TwitterGreyIcon = makeIcon({
  displayName: 'TwitterGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M5.079 14.5c5.944 0 9.196-5.002 9.196-9.34 0-.142 0-.283-.01-.424a6.634 6.634 0 0 0 1.613-1.699c-.59.266-1.216.44-1.857.517a3.285 3.285 0 0 0 1.421-1.816 6.417 6.417 0 0 1-2.052.797 3.22 3.22 0 0 0-1.834-.992 3.192 3.192 0 0 0-2.049.346 3.266 3.266 0 0 0-1.42 1.54 3.333 3.333 0 0 0-.205 2.1 9.065 9.065 0 0 1-3.69-.996 9.204 9.204 0 0 1-2.97-2.434A3.33 3.33 0 0 0 .866 4.49c.186.814.67 1.526 1.355 1.99A3.17 3.17 0 0 1 .755 6.07v.041c0 .758.259 1.493.731 2.08.473.586 1.13.988 1.862 1.138a3.179 3.179 0 0 1-1.46.056 3.285 3.285 0 0 0 1.15 1.632 3.204 3.204 0 0 0 1.87.648 6.422 6.422 0 0 1-4.783 1.36 9.047 9.047 0 0 0 4.954 1.472" />
    </g>
  ),
})

export const VimeoIcon = makeIcon({
  displayName: 'VimeoIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M16 3.2902C15.9262 4.84037 14.8374 6.98109 12.7336 9.69389C10.5559 12.499 8.7105 13.92 7.21569 13.92C6.27451 13.92 5.49942 13.0526 4.85352 11.3363C4.42907 9.74925 3.98616 8.18062 3.56171 6.59354C3.08189 4.87728 2.56517 4.00992 2.01153 4.00992C1.90081 4.00992 1.47636 4.26828 0.756632 4.76655L0 3.80692C0.793541 3.10565 1.56863 2.42284 2.34371 1.72157C3.39562 0.817303 4.18916 0.337488 4.72434 0.282124C5.96078 0.171398 6.73587 1.0203 7.03114 2.82884C7.34487 4.80346 7.56632 6.02146 7.67705 6.50127C8.02768 8.12526 8.43368 8.95571 8.85813 8.95571C9.19031 8.95571 9.68858 8.42053 10.3714 7.36863C11.0358 6.31673 11.4048 5.50473 11.4418 4.9511C11.534 4.04683 11.1834 3.58547 10.3714 3.58547C9.98385 3.58547 9.59631 3.67774 9.19031 3.84383C9.94694 1.26021 11.4602 0.00530778 13.6747 0.0791255C15.3172 0.134489 16.0923 1.20485 16 3.2902Z"
        fill="#1AB7EA"
      />
    </g>
  ),
})

export const VimeoGreyIcon = makeIcon({
  displayName: 'VimeoGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M16 3.2902C15.9262 4.84037 14.8374 6.98109 12.7336 9.69389C10.5559 12.499 8.7105 13.92 7.21569 13.92C6.27451 13.92 5.49942 13.0526 4.85352 11.3363C4.42907 9.74925 3.98616 8.18062 3.56171 6.59354C3.08189 4.87728 2.56517 4.00992 2.01153 4.00992C1.90081 4.00992 1.47636 4.26828 0.756632 4.76655L0 3.80692C0.793541 3.10565 1.56863 2.42284 2.34371 1.72157C3.39562 0.817303 4.18916 0.337488 4.72434 0.282124C5.96078 0.171398 6.73587 1.0203 7.03114 2.82884C7.34487 4.80346 7.56632 6.02146 7.67705 6.50127C8.02768 8.12526 8.43368 8.95571 8.85813 8.95571C9.19031 8.95571 9.68858 8.42053 10.3714 7.36863C11.0358 6.31673 11.4048 5.50473 11.4418 4.9511C11.534 4.04683 11.1834 3.58547 10.3714 3.58547C9.98385 3.58547 9.59631 3.67774 9.19031 3.84383C9.94694 1.26021 11.4602 0.00530778 13.6747 0.0791255C15.3172 0.134489 16.0923 1.20485 16 3.2902Z" />
    </g>
  ),
})

export const YouTubeIcon = makeIcon({
  displayName: 'YouTubeIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.67 4.152a2.029 2.029 0 0 0-1.422-1.421C12.998 2.4 8 2.4 8 2.4s-4.998 0-6.248.33A2.029 2.029 0 0 0 .33 4.153C0 5.402 0 8 0 8s0 2.61.33 3.848a2.029 2.029 0 0 0 1.422 1.421C3.002 13.6 8 13.6 8 13.6s5.01 0 6.248-.33a2.029 2.029 0 0 0 1.421-1.422C16 10.598 16 8 16 8s0-2.61-.33-3.848z"
        fill="red"
      />
      <path d="M6.395 10.402L10.56 8 6.395 5.598v4.804z" fill="#fff" />
    </g>
  ),
})

export const YouTubeGreyIcon = makeIcon({
  displayName: 'YouTubeGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.248 2.73a2.029 2.029 0 0 1 1.421 1.422C16 5.39 16 8 16 8s0 2.598-.33 3.848a2.029 2.029 0 0 1-1.422 1.421C13.011 13.6 8 13.6 8 13.6s-4.998 0-6.248-.33A2.029 2.029 0 0 1 .33 11.847C0 10.61 0 8 0 8s0-2.598.33-3.848a2.029 2.029 0 0 1 1.422-1.421C3.002 2.4 8 2.4 8 2.4s4.998 0 6.248.33zM10.56 8l-4.165 2.402V5.598L10.56 8z"
      />
    </g>
  ),
})

export const JiraIcon = makeIcon({
  displayName: 'JiraIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M8 0a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 15.999 8L16 .7a.7.7 0 0 0-.7-.7H8z"
        fill="#2684FF"
      />
      <path
        d="M4 4a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 12 12L12 4.7a.7.7 0 0 0-.7-.7H4z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M0 8a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 8 16L8 8.7a.7.7 0 0 0-.7-.7H0z"
        fill="url(#paint1_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="11.842"
          y1="4.013"
          x2="8.692"
          y2="7.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="7.842"
          y1="8.013"
          x2="4.692"
          y2="11.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </g>
  ),
})

export const JiraGreyIcon = makeIcon({
  displayName: 'JiraGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M8 0a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 15.999 8L16 .7a.7.7 0 0 0-.7-.7H8z" />
      <path d="M4 4a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 12 12L12 4.7a.7.7 0 0 0-.7-.7H4z" />
      <path d="M0 8a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 8 16L8 8.7a.7.7 0 0 0-.7-.7H0z" />
    </g>
  ),
})

export const MiroIcon = makeIcon({
  displayName: 'MiroIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="#ffd02f"
        d="M14.55 0H1.45C.65 0 0 .65 0 1.45v13.1C0 15.35.65 16 1.45 16h13.1c.8 0 1.45-.65 1.45-1.45V1.45C16 .65 15.35 0 14.55 0z"
      />
      <path
        fill="#050038"
        d="M10.902344 2.132812H9.195312l1.515626 2.351563-3.207032-2.351563H5.796875L7.3125 5.210938 4.109375 2.132812H2.398438l1.492187 3.976563-1.492187 7.757813h1.710937L7.3125 5.546875l-1.515625 8.320313h1.707031l3.207032-9.046876-1.515626 9.046876h1.707032l3.230468-9.9375Zm0 0"
      />
    </g>
  ),
})

export const MiroGreyIcon = makeIcon({
  displayName: 'MiroGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.902344 2.132812H9.195312l1.515626 2.351563-3.207032-2.351563H5.796875L7.3125 5.210938 4.109375 2.132812H2.398438l1.492187 3.976563-1.492187 7.757813h1.710937L7.3125 5.546875l-1.515625 8.320313h1.707031l3.207032-9.046876-1.515626 9.046876h1.707032l3.230468-9.9375Zm0 0"
      />
    </g>
  ),
})

export const OneDriveIcon = makeIcon({
  displayName: 'OneDriveIcon',
  viewBox: 24,
  content: (
    <g>
      <path
        d="m14.5 15 4.95-4.74A7.5 7.5 0 0 0 5.92 8c.08 0 8.58 7 8.58 7Z"
        fill="#0364b8"
      />
      <path
        d="M9.15 8.89A6 6 0 0 0 6 8h-.08a6 6 0 0 0-4.84 9.43l7.42-.93 5.69-4.59Z"
        fill="#0078d4"
      />
      <path
        d="M19.45 10.26h-.32a4.84 4.84 0 0 0-1.94.4l-3 1.26L17.5 16l5.92 1.44a4.88 4.88 0 0 0-4-7.18Z"
        fill="#1490df"
      />
      <path
        d="M1.08 17.43A6 6 0 0 0 6 20h13.13a4.89 4.89 0 0 0 4.29-2.56l-9.23-5.53Z"
        fill="#28a8ea"
      />
    </g>
  ),
})

export const OneDriveGreyIcon = makeIcon({
  displayName: 'OneDriveGreyIcon',
  viewBox: 24,
  content: (
    <g>
      <path
        d="m14.5 15 4.95-4.74A7.5 7.5 0 0 0 5.92 8c.08 0 8.58 7 8.58 7Z"
        fill="currentColor"
      />
      <path
        d="M9.15 8.89A6 6 0 0 0 6 8h-.08a6 6 0 0 0-4.84 9.43l7.42-.93 5.69-4.59Z"
        fill="currentColor"
      />
      <path
        d="M19.45 10.26h-.32a4.84 4.84 0 0 0-1.94.4l-3 1.26L17.5 16l5.92 1.44a4.88 4.88 0 0 0-4-7.18Z"
        fill="currentColor"
      />
      <path
        d="M1.08 17.43A6 6 0 0 0 6 20h13.13a4.89 4.89 0 0 0 4.29-2.56l-9.23-5.53Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const SharepointIcon = makeIcon({
  displayName: 'SharepointIcon',
  viewBox: 16,
  content: (
    <>
      <g>
        <path
          d="M8.18604 8.91428C10.6521 8.91428 12.6512 6.91875 12.6512 4.45714C12.6512 1.99553 10.6521 0 8.18604 0C5.72002 0 3.72092 1.99553 3.72092 4.45714C3.72092 6.91875 5.72002 8.91428 8.18604 8.91428Z"
          fill="#036C70"
        />
        <path
          d="M11.907 12.6286C14.1675 12.6286 16 10.7993 16 8.54287C16 6.28639 14.1675 4.45715 11.907 4.45715C9.64646 4.45715 7.81395 6.28639 7.81395 8.54287C7.81395 10.7993 9.64646 12.6286 11.907 12.6286Z"
          fill="#1A9BA1"
        />
        <path
          d="M8.74418 15.6C10.4909 15.6 11.907 14.1865 11.907 12.4428C11.907 10.6992 10.4909 9.28571 8.74418 9.28571C6.99742 9.28571 5.58139 10.6992 5.58139 12.4428C5.58139 14.1865 6.99742 15.6 8.74418 15.6Z"
          fill="#37C6D0"
        />
        <path
          d="M0.682046 3.71429H7.50399C7.88068 3.71429 8.18604 4.01911 8.18604 4.39512V11.2049C8.18604 11.5809 7.88068 11.8857 7.50399 11.8857H0.682046C0.305362 11.8857 0 11.5809 0 11.2049V4.39512C0 4.01911 0.305362 3.71429 0.682046 3.71429Z"
          fill="url(#sharepoint_gradient)"
        />
        <path
          d="M3.04633 7.7168C2.88649 7.61096 2.75298 7.47007 2.656 7.30488C2.56203 7.13219 2.51519 6.93788 2.52018 6.74142C2.51181 6.47543 2.60173 6.21565 2.77283 6.01156C2.95262 5.80722 3.18502 5.65591 3.44483 5.57402C3.74093 5.47673 4.05107 5.42879 4.36278 5.43214C4.7727 5.41718 5.18204 5.4744 5.57208 5.60114V6.45543C5.40261 6.35294 5.21802 6.27773 5.0251 6.23257C4.81578 6.18133 4.601 6.15563 4.38547 6.15605C4.1582 6.14772 3.93239 6.19544 3.72799 6.29497C3.57018 6.36291 3.46785 6.51788 3.46752 6.68943C3.46688 6.79349 3.50693 6.89369 3.57915 6.96874C3.66446 7.05722 3.76536 7.12924 3.87683 7.1812C4.00086 7.24286 4.18691 7.32482 4.43497 7.42709C4.46228 7.43571 4.4889 7.44639 4.51459 7.45904C4.75874 7.55428 4.99426 7.67022 5.2186 7.80558C5.38848 7.91014 5.53106 8.05348 5.6346 8.2238C5.74075 8.41688 5.7922 8.63517 5.78343 8.85524C5.79555 9.12832 5.71185 9.39707 5.54678 9.61518C5.38225 9.81569 5.16227 9.96346 4.91422 10.0401C4.62247 10.1314 4.31798 10.1755 4.01227 10.1708C3.73799 10.1721 3.4641 10.1497 3.19367 10.104C2.96532 10.0667 2.74248 10.0013 2.53023 9.90934V9.00863C2.73312 9.15327 2.95979 9.26138 3.2 9.32806C3.43939 9.40253 3.68825 9.4423 3.93897 9.44618C4.17102 9.46085 4.40266 9.41178 4.60874 9.30429C4.7531 9.22297 4.8409 9.06895 4.83721 8.90352C4.83817 8.78841 4.79256 8.67779 4.7107 8.59672C4.6089 8.49696 4.49104 8.41498 4.36205 8.35418C4.21321 8.27989 3.99405 8.18196 3.70456 8.06037C3.47426 7.96795 3.25376 7.85286 3.04633 7.7168Z"
          fill="white"
        />
      </g>
      <linearGradient
        id="sharepoint_gradient"
        x1="1.42208"
        y1="3.18231"
        x2="6.74965"
        y2="12.426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#058F92" />
        <stop offset="0.5" stopColor="#038489" />
        <stop offset="1" stopColor="#026D71" />
      </linearGradient>
    </>
  ),
})

export const HubspotIcon = makeIcon({
  displayName: 'HubspotIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M11.7311 5.26612V3.36069C12.2448 3.12059 12.5743 2.60571 12.5777 2.03861V1.99453C12.5777 1.18327 11.9197 0.525518 11.1084 0.525518H11.0656C10.2543 0.525518 9.59656 1.18327 9.59656 1.99453V2.03861C9.59869 2.31725 9.68003 2.58955 9.8311 2.8237C9.98216 3.05785 10.1967 3.2442 10.4497 3.361V5.26612C9.72661 5.37648 9.04353 5.67816 8.47425 6.13646L3.24752 2.06831C3.28472 1.93419 3.30473 1.79539 3.3066 1.65658V1.65315C3.3066 0.740289 2.56631 0 1.65315 0C0.740289 0 0 0.740289 0 1.65315C0 2.56538 0.739039 3.30535 1.65096 3.3066C1.93763 3.3041 2.21868 3.22564 2.46565 3.08058L7.61204 7.08433C7.16048 7.76688 6.91957 8.56714 6.91927 9.38554C6.91927 10.2418 7.18374 11.079 7.67519 11.7796L6.1102 13.3446C5.98405 13.3072 5.85318 13.2882 5.72161 13.288C4.97257 13.288 4.36546 13.8951 4.36546 14.6438C4.36546 15.3929 4.97257 16 5.72161 16C6.47034 16 7.07745 15.3929 7.07745 14.6438V14.6398C7.07636 14.5071 7.05507 14.3753 7.0143 14.249L8.56241 12.6996C9.29302 13.2625 10.1893 13.5678 11.1115 13.5681C13.4174 13.5681 15.2872 11.6983 15.2872 9.39242C15.2872 7.32755 13.7773 5.57218 11.7355 5.26393L11.7311 5.26612ZM11.0937 11.5311C9.94357 11.4835 9.03509 10.5372 9.03509 9.38585C9.03509 8.27823 9.87823 7.35193 10.9805 7.24814H11.0937C12.2129 7.33349 13.0776 8.26667 13.0776 9.38898C13.0776 10.5116 12.2129 11.4448 11.094 11.5298L11.0937 11.5311Z"
        fill="#FF7A59"
      />
    </g>
  ),
})

export const HubspotGreyIcon = makeIcon({
  displayName: 'HubspotGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M11.7311 5.26612V3.36069C12.2448 3.12059 12.5743 2.60571 12.5777 2.03861V1.99453C12.5777 1.18327 11.9197 0.525518 11.1084 0.525518H11.0656C10.2543 0.525518 9.59656 1.18327 9.59656 1.99453V2.03861C9.59869 2.31725 9.68003 2.58955 9.8311 2.8237C9.98216 3.05785 10.1967 3.2442 10.4497 3.361V5.26612C9.72661 5.37648 9.04353 5.67816 8.47425 6.13646L3.24752 2.06831C3.28472 1.93419 3.30473 1.79539 3.3066 1.65658V1.65315C3.3066 0.740289 2.56631 0 1.65315 0C0.740289 0 0 0.740289 0 1.65315C0 2.56538 0.739039 3.30535 1.65096 3.3066C1.93763 3.3041 2.21868 3.22564 2.46565 3.08058L7.61204 7.08433C7.16048 7.76688 6.91957 8.56714 6.91927 9.38554C6.91927 10.2418 7.18374 11.079 7.67519 11.7796L6.1102 13.3446C5.98405 13.3072 5.85318 13.2882 5.72161 13.288C4.97257 13.288 4.36546 13.8951 4.36546 14.6438C4.36546 15.3929 4.97257 16 5.72161 16C6.47034 16 7.07745 15.3929 7.07745 14.6438V14.6398C7.07636 14.5071 7.05507 14.3753 7.0143 14.249L8.56241 12.6996C9.29302 13.2625 10.1893 13.5678 11.1115 13.5681C13.4174 13.5681 15.2872 11.6983 15.2872 9.39242C15.2872 7.32755 13.7773 5.57218 11.7355 5.26393L11.7311 5.26612ZM11.0937 11.5311C9.94357 11.4835 9.03509 10.5372 9.03509 9.38585C9.03509 8.27823 9.87823 7.35193 10.9805 7.24814H11.0937C12.2129 7.33349 13.0776 8.26667 13.0776 9.38898C13.0776 10.5116 12.2129 11.4448 11.094 11.5298L11.0937 11.5311Z"
      />
    </g>
  ),
})

export const GitIcon = makeIcon({
  displayName: 'GitIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.2924 7.32504L8.6748 0.707802C8.29377 0.326607 7.67571 0.326607 7.29435 0.707802L5.92033 2.08215L7.66334 3.82516C8.06845 3.68826 8.53295 3.78013 8.85575 4.1031C9.18054 4.42805 9.27159 4.8965 9.13122 5.3031L10.8114 6.9831C11.218 6.8429 11.6868 6.93362 12.0114 7.25873C12.465 7.71234 12.465 8.44735 12.0114 8.90129C11.5574 9.35506 10.8224 9.35506 10.3683 8.90129C10.0272 8.55984 9.94276 8.0584 10.1158 7.63811L8.54878 6.07127V10.1945C8.6593 10.2492 8.76371 10.3222 8.85575 10.4142C9.30936 10.8678 9.30936 11.6028 8.85575 12.0569C8.40214 12.5104 7.66664 12.5104 7.21336 12.0569C6.75975 11.6026 6.75975 10.8676 7.21336 10.4142C7.32553 10.3022 7.45534 10.2174 7.5939 10.1607V5.99902C7.45534 5.94228 7.32586 5.85832 7.21336 5.74549C6.86977 5.40207 6.78713 4.89766 6.9633 4.47572L5.24503 2.75712L0.707299 7.29436C0.326103 7.67589 0.326103 8.29395 0.707299 8.67514L7.3252 15.2925C7.70623 15.6737 8.32412 15.6737 8.70565 15.2925L15.2924 8.70582C15.6736 8.32463 15.6736 7.70624 15.2924 7.32504Z"
        fill="#F05133"
      />
    </g>
  ),
})

export const GitGreyIcon = makeIcon({
  displayName: 'GitGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M15.2924 7.32504L8.6748 0.707802C8.29377 0.326607 7.67571 0.326607 7.29435 0.707802L5.92033 2.08215L7.66334 3.82516C8.06845 3.68826 8.53295 3.78013 8.85575 4.1031C9.18054 4.42805 9.27159 4.8965 9.13122 5.3031L10.8114 6.9831C11.218 6.8429 11.6868 6.93362 12.0114 7.25873C12.465 7.71234 12.465 8.44735 12.0114 8.90129C11.5574 9.35506 10.8224 9.35506 10.3683 8.90129C10.0272 8.55984 9.94276 8.0584 10.1158 7.63811L8.54878 6.07127V10.1945C8.6593 10.2492 8.76371 10.3222 8.85575 10.4142C9.30936 10.8678 9.30936 11.6028 8.85575 12.0569C8.40214 12.5104 7.66664 12.5104 7.21336 12.0569C6.75975 11.6026 6.75975 10.8676 7.21336 10.4142C7.32553 10.3022 7.45534 10.2174 7.5939 10.1607V5.99902C7.45534 5.94228 7.32586 5.85832 7.21336 5.74549C6.86977 5.40207 6.78713 4.89766 6.9633 4.47572L5.24503 2.75712L0.707299 7.29436C0.326103 7.67589 0.326103 8.29395 0.707299 8.67514L7.3252 15.2925C7.70623 15.6737 8.32412 15.6737 8.70565 15.2925L15.2924 8.70582C15.6736 8.32463 15.6736 7.70624 15.2924 7.32504Z"
      />
    </g>
  ),
})

export const AttioIcon = makeIcon({
  displayName: 'AttioIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.8424 11.048L14.5025 8.94199L14.3711 8.75999C14.1609 8.44799 13.8194 8.26599 13.4516 8.26599L11.2972 8.23999L11.1658 8.49999L8.59113 12.582L8.45977 12.816L9.53695 14.532C9.74713 14.844 10.0887 15.026 10.4565 15.026H13.4778C13.8456 15.026 14.2135 14.844 14.3974 14.532L14.5025 14.376L15.8424 12.244C16.0525 11.854 16.0525 11.412 15.8424 11.048ZM15.422 11.958L14.0821 14.09C14.0821 14.09 14.0821 14.116 14.0558 14.116C14.0033 14.168 13.9507 14.168 13.9245 14.168C13.8982 14.168 13.8194 14.168 13.7668 14.09L12.4269 11.958C12.4007 11.932 12.4007 11.906 12.3744 11.88C12.3744 11.854 12.3481 11.828 12.3481 11.802C12.3218 11.698 12.3218 11.594 12.3481 11.464C12.3744 11.412 12.3744 11.36 12.4269 11.308L13.7668 9.20199C13.7931 9.14999 13.8456 9.12399 13.8719 9.12399C13.8982 9.12399 13.8982 9.12399 13.8982 9.12399C13.8982 9.12399 13.8982 9.12399 13.9245 9.12399C13.9507 9.12399 14.0296 9.12399 14.0821 9.20199L15.422 11.308C15.5534 11.516 15.5534 11.75 15.422 11.958Z"
        fill="black"
      />
      <path
        d="M11.8752 5.926C12.0854 5.588 12.0854 5.12 11.8752 4.782L10.5353 2.676L10.4302 2.494C10.22 2.182 9.87849 2 9.51067 2H6.48933C6.12151 2 5.77997 2.182 5.56979 2.494L0.157635 11.074C0.0525452 11.23 0 11.438 0 11.62C0 11.828 0.0525452 12.01 0.157635 12.192L1.60263 14.48C1.81281 14.818 2.15435 15 2.54844 15H5.56979C5.9376 15 6.30542 14.818 6.48933 14.506L6.59442 14.324L7.67159 12.608L10.8506 7.564L11.8752 5.926ZM11.5599 5.38C11.5599 5.484 11.5337 5.588 11.4548 5.692L6.17406 14.064C6.12151 14.142 6.04269 14.142 6.01642 14.142C5.99015 14.142 5.91133 14.142 5.85878 14.064L4.51888 11.932C4.38752 11.75 4.38752 11.49 4.51888 11.308L9.82594 2.936C9.87849 2.858 9.95731 2.858 9.98358 2.858C10.0099 2.858 10.0887 2.858 10.1412 2.936L11.4811 5.042C11.5337 5.146 11.5599 5.25 11.5599 5.38Z"
        fill="black"
      />
    </g>
  ),
})

export const AttioGreyIcon = makeIcon({
  displayName: 'AttioGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.8424 11.048L14.5025 8.94199L14.3711 8.75999C14.1609 8.44799 13.8194 8.26599 13.4516 8.26599L11.2972 8.23999L11.1658 8.49999L8.59113 12.582L8.45977 12.816L9.53695 14.532C9.74713 14.844 10.0887 15.026 10.4565 15.026H13.4778C13.8456 15.026 14.2135 14.844 14.3974 14.532L14.5025 14.376L15.8424 12.244C16.0525 11.854 16.0525 11.412 15.8424 11.048ZM15.422 11.958L14.0821 14.09C14.0821 14.09 14.0821 14.116 14.0558 14.116C14.0033 14.168 13.9507 14.168 13.9245 14.168C13.8982 14.168 13.8194 14.168 13.7668 14.09L12.4269 11.958C12.4007 11.932 12.4007 11.906 12.3744 11.88C12.3744 11.854 12.3481 11.828 12.3481 11.802C12.3218 11.698 12.3218 11.594 12.3481 11.464C12.3744 11.412 12.3744 11.36 12.4269 11.308L13.7668 9.20199C13.7931 9.14999 13.8456 9.12399 13.8719 9.12399C13.8982 9.12399 13.8982 9.12399 13.8982 9.12399C13.8982 9.12399 13.8982 9.12399 13.9245 9.12399C13.9507 9.12399 14.0296 9.12399 14.0821 9.20199L15.422 11.308C15.5534 11.516 15.5534 11.75 15.422 11.958Z"
        fill="currentColor"
      />
      <path
        d="M11.8752 5.926C12.0854 5.588 12.0854 5.12 11.8752 4.782L10.5353 2.676L10.4302 2.494C10.22 2.182 9.87849 2 9.51067 2H6.48933C6.12151 2 5.77997 2.182 5.56979 2.494L0.157635 11.074C0.0525452 11.23 0 11.438 0 11.62C0 11.828 0.0525452 12.01 0.157635 12.192L1.60263 14.48C1.81281 14.818 2.15435 15 2.54844 15H5.56979C5.9376 15 6.30542 14.818 6.48933 14.506L6.59442 14.324L7.67159 12.608L10.8506 7.564L11.8752 5.926ZM11.5599 5.38C11.5599 5.484 11.5337 5.588 11.4548 5.692L6.17406 14.064C6.12151 14.142 6.04269 14.142 6.01642 14.142C5.99015 14.142 5.91133 14.142 5.85878 14.064L4.51888 11.932C4.38752 11.75 4.38752 11.49 4.51888 11.308L9.82594 2.936C9.87849 2.858 9.95731 2.858 9.98358 2.858C10.0099 2.858 10.0887 2.858 10.1412 2.936L11.4811 5.042C11.5337 5.146 11.5599 5.25 11.5599 5.38Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const GmailIcon = makeIcon({
  displayName: 'GmailIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="#4285F4"
        d="M1.09 14h2.546V7.818L0 5.091v7.818C0 13.513.49 14 1.09 14"
      />
      <path
        fill="#34A853"
        d="M12.364 14h2.545c.604 0 1.091-.49 1.091-1.09V5.09l-3.636 2.728"
      />
      <path
        fill="#FBBC04"
        d="M12.364 3.09v4.728L16 5.091V3.636c0-1.349-1.54-2.118-2.618-1.309"
      />
      <path
        fill="#EA4335"
        d="M3.636 7.818V3.091L8 6.364l4.364-3.273v4.727L8 11.091"
      />
      <path
        fill="#C5221F"
        d="M0 3.636v1.455l3.636 2.727V3.091l-1.018-.764C1.538 1.518 0 2.287 0 3.637"
      />
    </g>
  ),
})

export const BlueskyIcon = makeIcon({
  displayName: 'BlueskyIcon',
  viewBox: 16,
  content: (
    <path
      d="M3.46821 1.94827C5.30257 3.3254 7.27564 6.11763 8.00005 7.6161C8.72451 6.11774 10.6975 3.32537 12.5319 1.94827C13.8555 0.954596 16 0.185745 16 2.63227C16 3.12087 15.7199 6.7368 15.5556 7.32383C14.9844 9.36475 12.9033 9.8853 11.0521 9.57024C14.288 10.121 15.1111 11.9452 13.3334 13.7694C9.95717 17.2339 8.48076 12.9001 8.10228 11.7896C8.03293 11.5861 8.00048 11.4908 8 11.5718C7.99952 11.4908 7.96707 11.5861 7.89772 11.7896C7.5194 12.9001 6.04303 17.234 2.66658 13.7694C0.888822 11.9452 1.71196 10.1209 4.94786 9.57024C3.09662 9.8853 1.01547 9.36475 0.444439 7.32383C0.280131 6.73674 0 3.12082 0 2.63227C0 0.185745 2.14459 0.954596 3.46812 1.94827H3.46821Z"
      fill="#1185FE"
    />
  ),
})

export const BlueskyGreyIcon = makeIcon({
  displayName: 'BlueskyGreyIcon',
  viewBox: 16,
  content: (
    <path
      d="M3.46821 1.94827C5.30257 3.3254 7.27564 6.11763 8.00005 7.6161C8.72451 6.11774 10.6975 3.32537 12.5319 1.94827C13.8555 0.954596 16 0.185745 16 2.63227C16 3.12087 15.7199 6.7368 15.5556 7.32383C14.9844 9.36475 12.9033 9.8853 11.0521 9.57024C14.288 10.121 15.1111 11.9452 13.3334 13.7694C9.95717 17.2339 8.48076 12.9001 8.10228 11.7896C8.03293 11.5861 8.00048 11.4908 8 11.5718C7.99952 11.4908 7.96707 11.5861 7.89772 11.7896C7.5194 12.9001 6.04303 17.234 2.66658 13.7694C0.888822 11.9452 1.71196 10.1209 4.94786 9.57024C3.09662 9.8853 1.01547 9.36475 0.444439 7.32383C0.280131 6.73674 0 3.12082 0 2.63227C0 0.185745 2.14459 0.954596 3.46812 1.94827H3.46821Z"
      fill="currentColor"
    />
  ),
})

export const DustIcon = makeIcon({
  displayName: 'DustIcon',
  viewBox: 48,
  content: (
    <g clip-path="url(#clip0_5641_63234)">
      <path d="M0.5 1.15398e-05H12.5V24H0.5V1.15398e-05Z" fill="#D8DADF" />
      <path
        d="M48.5 1.04907e-06V12L24.5 12V0L48.5 1.04907e-06Z"
        fill="#D8DADF"
      />
      <path
        d="M24.5 12C24.5 18.6274 19.1274 24 12.5 24V1.15398e-05C19.1274 1.15398e-05 24.5 5.37258 24.5 12Z"
        fill="white"
      />
      <path
        d="M36.5 24C29.8726 24 24.5 18.6274 24.5 12L48.5 12C48.5 18.6274 43.1274 24 36.5 24Z"
        fill="white"
      />
      <path
        d="M0.5 36H12.5C15.8137 36 18.5 38.6863 18.5 42C18.5 45.3137 15.8137 48 12.5 48H0.5V36Z"
        fill="white"
      />
      <path
        d="M48.5 36H12.5C9.18629 36 6.5 33.3137 6.5 30C6.5 26.6863 9.18629 24 12.5 24L48.5 24V36Z"
        fill="#D8DADF"
      />
      <path d="M24.5 36H36.5V48H24.5V36Z" fill="white" />
    </g>
  ),
})

export const GuruIcon = makeIcon({
  displayName: 'GuruIcon',
  viewBox: 48,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.9922 28.4767C48.1611 34.4532 45.5705 38.9234 40.4738 41.7899C33.4033 45.7699 25.8198 48.1559 17.6131 47.893C12.9871 47.7436 9.28955 45.5232 6.86454 41.6568C2.21905 34.2519 -0.277376 26.1328 0.0245322 17.3418C0.183602 12.7255 2.56965 9.09612 6.46524 6.71332C13.8019 2.22365 21.7944 -0.266282 30.4556 0.0226406C35.1498 0.178464 38.7727 2.61321 41.2399 6.54451C45.4439 13.2417 47.4014 20.6595 47.9955 28.4767H47.9922ZM27.3101 32.9956C25.4597 33.6709 23.4762 33.7845 21.7265 33.317C17.3764 32.1483 14.2177 28.1489 14.2177 23.8053C14.2177 20.3447 15.776 18.0788 17.081 16.7867C18.8794 15.011 21.3759 13.9559 23.7846 13.9559H23.8755C28.4658 14.0046 31.3745 17.475 31.4005 17.5074C31.7998 17.9976 32.5173 18.069 33.0075 17.673C33.4976 17.2737 33.5723 16.5562 33.173 16.066C33.0302 15.8875 29.5858 11.7354 23.9015 11.6738C20.8305 11.6575 17.753 12.9139 15.4773 15.1636C13.1951 17.423 11.9355 20.4908 11.9355 23.8053C11.9355 29.1617 15.8052 34.0897 21.1356 35.5213C22.0381 35.7648 22.9828 35.8849 23.9437 35.8849C25.3299 35.8849 26.7453 35.6349 28.0958 35.1415C31.6083 33.8559 35.0364 30.4797 34.913 26.5777C34.1404 27.1458 33.2964 27.6652 32.4069 28.1521C31.7219 30.2979 29.5631 32.1743 27.3134 32.9956H27.3101ZM33.4645 23.2307C34.9319 22.1757 35.9155 21.1239 35.935 21.1012V21.0979C36.3635 20.6337 37.0874 20.6045 37.5484 21.033C38.0126 21.4615 38.0418 22.1822 37.6133 22.6464L37.6131 22.6467C37.5174 22.749 36.3946 23.9491 34.6916 25.1526C34.3637 25.3863 33.6366 25.8992 32.6205 26.4154C31.1661 27.1588 29.504 27.7107 27.8029 27.6685C24.7514 27.6035 23.6411 25.9219 23.6152 24.3702C23.6022 23.5067 23.9008 22.7405 24.4754 22.1562C25.2091 21.4128 26.3129 21.0362 27.751 21.0362C29.5072 21.0362 31.9387 21.7439 33.4645 23.2307ZM25.9006 24.3377C25.9136 25.172 26.9686 25.3701 27.8516 25.3896C29.0885 25.4155 30.2864 25.0325 31.3966 24.4871C30.361 23.7469 28.871 23.3184 27.751 23.3184C26.6959 23.3184 26.2674 23.5943 26.1051 23.7599C26.0531 23.8118 25.8941 23.9742 25.9006 24.3377Z"
      fill="currentColor"
    />
  ),
})

export const GleanIcon = makeIcon({
  displayName: 'GleanIcon',
  viewBox: 32,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0942 3.83196L22.102 0L25.7518 2.83837L22.766 6.64223C24.3073 8.4768 25.235 10.8397 25.235 13.4183C25.235 19.2554 20.4812 23.9872 14.617 23.9872C8.75286 23.9872 3.99902 19.2554 3.99902 13.4183C3.99902 7.58114 8.75286 2.84926 14.617 2.84926C16.2167 2.84926 17.7337 3.20136 19.0942 3.83196ZM14.617 19.448C11.2714 19.448 8.55924 16.7484 8.55924 13.4183C8.55924 10.0881 11.2714 7.38842 14.617 7.38842C17.9627 7.38842 20.6748 10.0881 20.6748 13.4183C20.6748 16.7484 17.9627 19.448 14.617 19.448ZM25.3585 22.4598C25.0955 22.7698 24.8184 23.0658 24.5291 23.3538C24.2399 23.6397 23.9384 23.9136 23.6249 24.1733C23.3134 24.433 22.9896 24.6786 22.6538 24.9102C22.3201 25.1419 21.9742 25.3612 21.6201 25.5627C21.2681 25.7661 20.9061 25.9512 20.5359 26.1224C20.1677 26.2935 19.7914 26.4487 19.4071 26.5856C19.0247 26.7244 18.6363 26.8453 18.2398 26.948C17.8494 27.0546 17.4509 27.1413 17.0484 27.2098C16.6498 27.2801 16.2452 27.3326 15.8366 27.3668C15.4341 27.4011 15.0275 27.4191 14.6168 27.4191C14.2062 27.4191 13.7996 27.4011 13.397 27.3668C12.9884 27.3326 12.5838 27.2801 12.1853 27.2098C11.7827 27.1413 11.3842 27.0546 10.9938 26.948L9.80227 31.3738C10.3201 31.5127 10.8501 31.6296 11.3862 31.7222C11.9142 31.8149 12.4523 31.8852 12.9965 31.9297C13.5305 31.9758 14.0706 32 14.6168 32C15.163 32 15.7031 31.9758 16.2372 31.9297C16.7813 31.8852 17.3174 31.8149 17.8474 31.7222C18.3835 31.6296 18.9115 31.5127 19.4313 31.3738C19.9573 31.2368 20.4752 31.0759 20.981 30.8906C21.4928 30.7073 21.9925 30.5019 22.4819 30.2744C22.9735 30.0469 23.4549 29.7992 23.9223 29.5313C24.3915 29.2616 24.8488 28.9717 25.2917 28.6615C25.7368 28.3534 26.1677 28.0273 26.5824 27.6809C26.9991 27.3346 27.3997 26.9722 27.7819 26.5916C28.1663 26.2111 28.5324 25.8163 28.8824 25.4036C29.2324 24.9928 29.5642 24.564 29.8757 24.1229L26.107 21.4953C25.8723 21.8274 25.6215 22.1497 25.3585 22.4598Z"
      fill="currentColor"
    />
  ),
})

export const ZendeskIcon = makeIcon({
  displayName: 'ZendeskIcon',
  viewBox: 16,
  content: (
    <path
      fill="#16140C"
      d="M7.397 13.97H.085l7.312-8.808v8.808ZM12.259 10.321a3.65 3.65 0 0 1 3.655 3.648H8.603a3.652 3.652 0 0 1 3.656-3.648ZM8.603 10.809V2h7.312l-7.312 8.809ZM7.397 2a3.652 3.652 0 0 1-3.656 3.648A3.652 3.652 0 0 1 .085 2h7.312Z"
    />
  ),
})
